import React from 'react';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import RadioYesNoInputComponent from './RadioYesNoInputComponent';

interface Props {
  question: FlowsQuestion;
}
const RadioInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  switch (null) {
    default:
      return <RadioYesNoInputComponent question={question} />;
  }
};

export default RadioInputPicker;
